var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":"primary","dark":"","flat":"","dense":"","height":40}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }